import { useState } from "react";
import { MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput } from "mdbreact";
import ReCAPTCHA from "react-google-recaptcha";
import locale from "locale";
import config from "config";
import EmailService from "Services/EmailService";

const HomeNewsletter = () => {
  const [value, setValue] = useState(false);
  const [email, setEmail] = useState("");
  const [succes, setSucces] = useState(false);

  function onChange(value) {
    setValue(value);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (value) {
        await EmailService.subscribeToNewsletter({ email });
        setEmail("");
        setSucces(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <section className="moz-p-home__section">
      <h2 className="mb-4 text-center mt-5 pt-5 font-weight-bold heading-secondary">
        {locale.NEWSLETTER.NEWSLETTER}
      </h2>
      <p className="lead grey-text w-responsive mx-auto text-center paragraph--lead">
        {locale.NEWSLETTER.DESCRIPTION}
      </p>
      <MDBRow style={{ marginBottom: 125 }}>
        <MDBCol />
        <MDBCol md="6">
          {succes && (
            <p className="moz-p-home__newsletter-success-message">
              {locale.NEWSLETTER.SUCCESS_MESSAGE}
            </p>
          )}
          <form onSubmit={handleSubmit}>
            <div className="grey-text md-form moz-p-home__newsletter-form">
              <MDBInput
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                label={locale.NEWSLETTER.EMAIL_PLACEHOLDER}
                icon="envelope"
                iconClass="grey-text"
                type="email"
                size="lg"
                required
              />
            </div>
            <ReCAPTCHA sitekey={config.RECAPTCHA_KEY} onChange={onChange} />
            <div className="text-center">
              <MDBBtn
                outline
                color={!value ? "elegant" : "primary"}
                type="submit"
                disabled={!value}
              >
                {locale.COMMON.SEND}
                <MDBIcon far icon="paper-plane" className="ml-1" />
              </MDBBtn>
            </div>
          </form>
        </MDBCol>
        <MDBCol />
      </MDBRow>
    </section>
  );
};

export default HomeNewsletter;
